/**
 * tinode-js: _routeData ends with a synthetic _routeInfo({ what:'read', from, seq, _noForwarding })
 * for every incoming {data}. For trip_automated messages that makes the system sender count
 * toward msgReadCount() → false read ticks on your bubbles.
 *
 * Fix: patch Topic.prototype (the base class shared by grp/p2p topics) — NOT TopicMe.prototype.
 * Walk the prototype chain from any topic instance to find where _routeData is an own property.
 */
export function applyTinodeTripAutomatedReadPatch(tinode) {
  if (!tinode || tinode._tripAutomatedReadPatchApplied) return;

  // getMeTopic() creates/returns a TopicMe instance. Walk up the chain to find the base
  // Topic.prototype where _routeData is actually defined as an own property.
  const anyTopic = tinode.getMeTopic();
  if (!anyTopic) return;

  let proto = Object.getPrototypeOf(anyTopic);
  while (proto && !Object.prototype.hasOwnProperty.call(proto, '_routeData')) {
    proto = Object.getPrototypeOf(proto);
  }
  if (!proto || typeof proto._routeData !== 'function' || typeof proto._routeInfo !== 'function') return;

  tinode._tripAutomatedReadPatchApplied = true;

  const origData = proto._routeData;
  const origInfo = proto._routeInfo;

  proto._routeData = function(data) {
    const h = data && data.head;
    const trip = !!(h && (h.trip_automated === true || h.trip_automated === 1));
    const from = data && data.from;
    this._angkasSkipSynthRead =
      trip && from && !this._tinode.isMe(from) ? { from, seq: data.seq | 0 } : null;
    try {
      origData.call(this, data);
    } finally {
      this._angkasSkipSynthRead = null;
    }
  };

  proto._routeInfo = function(info) {
    const skip = this._angkasSkipSynthRead;
    if (
      skip &&
      info &&
      info._noForwarding &&
      info.what === 'read' &&
      info.from === skip.from &&
      (info.seq | 0) === skip.seq
    ) {
      return;
    }
    return origInfo.call(this, info);
  };
}
